import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "@jti/store";
import { useConfig } from "@jti/ui";
export const useFreeTrial = () => {
    const { order, id } = useSelector((state) => state.freeTrialCart);
    const { pathname = "" } = useLocation();
    const history = useHistory();
    const config = useConfig();
    const isFreeTrial = pathname.startsWith("/trial/");
    if (isFreeTrial && config["trials-store-view"] === undefined) {
        history.push("/");
    }
    return {
        isFreeTrial,
        freeTrialId: id,
        freeTrialOrderState: order,
    };
};
//# sourceMappingURL=useFreeTrial.js.map